import { SpectacleThemeOverrides } from './default-theme';

const printTheme: SpectacleThemeOverrides = {
  colors: {
    primary: '#777',
    secondary: '#000',
    tertiary: '#fff',
    quaternary: '#000000',
    quinary: '#000000'
  }
};
export default printTheme;
